import ReactDOM from 'react-dom';

export default function PortalTop({ children, name }) {
  const containerId = `root-modal-top-${name}`;
  let modalRoot = document.getElementById(containerId);

  if (!modalRoot) {
    const tempEl = document.createElement('div');
    tempEl.id = containerId;
    tempEl.style.position = 'relative';
    tempEl.style.zIndex = 9999;

    document.body.appendChild(tempEl);
    modalRoot = tempEl;
  }

  return ReactDOM.createPortal(children, modalRoot);
}
